module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "width": "100%"
    }
  }, [_c('AdminTools'), _vm._v(" "), _c('div', {
    staticClass: "flexContainer full what"
  }, [_c('section', {
    attrs: {
      "id": "sectionPrincipal"
    }
  }, [_c('section', {
    staticClass: "brand-list"
  }, [_c('section', {
    staticClass: "searchResultsWrapper"
  }, [_c('h1', {
    staticClass: "headline uppercase"
  }, [_vm._v("Properties Type")]), _vm._v(" "), _c('section', [_vm._m(0), _vm._v(" "), _c('hr', {
    staticClass: "full mt10 separator"
  }), _vm._v(" "), _vm._l((_vm.properties), function(property) {
    return _c('div', {
      key: property.id,
      staticClass: "listDisplay rel full flexContainer fd-c ai-c jc-fs"
    }, [_c('div', {
      staticClass: "listDisplay rel full flexContainer fd-c ai-c jc-fs list"
    }, [_c('div', {
      staticClass: "listDisplay full ai-c jc-sb flexContainer"
    }, [_c('div', {
      staticClass: "flexContainer fd-c size1of6"
    }, [_c('span', {
      staticClass: "listTitle uppercase center"
    }, [_vm._v(_vm._s(property.name))])]), _vm._v(" "), _c('div', {
      staticClass: "flexContainer fd-c size2of6"
    }, _vm._l((property.brandComponentPropertyTypes.map(function (bcpt) { return bcpt.brand; })), function(brand) {
      return _c('ul', [_c('li', [_vm._v(_vm._s(brand.name))])])
    })), _vm._v(" "), _c('div', {
      staticClass: "flexContainer fd-c size2of6"
    }, _vm._l((property.componentTypeComponentPropertyTypes.map(function (ctcpt) { return ctcpt.componentType; })), function(componentType) {
      return _c('ul', [_c('li', [_vm._v(_vm._s(componentType.name))])])
    }))])])])
  })], 2)])])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "flexContainer ai-c jc-sb"
  }, [_c('div', {
    staticClass: "flexContainer ai-c jc-sb"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5bf21bb5","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/properties/Properties.vue
// module id = 3211
// module chunks = 0